import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "cinema-search-input-wrap" }
const _hoisted_2 = { class: "cinema-search-input" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "icomoon-Search" }, null, -1)
const _hoisted_4 = { class: "search-results-wrap" }
const _hoisted_5 = { class: "search-results" }
const _hoisted_6 = {
  key: 0,
  class: "search-result-box history"
}
const _hoisted_7 = { class: "search-history-head" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "搜索历史", -1)
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "icomoon-record" }, null, -1)
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 1,
  class: "search-history-empty"
}
const _hoisted_13 = {
  key: 1,
  class: "search-result-box"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "poster-box" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "info" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "tags" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "series" }
const _hoisted_23 = {
  key: 2,
  class: "loading-wrap"
}
const _hoisted_24 = {
  key: 3,
  class: "search-result-abnormal"
}
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 查看")
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 所有影片搜索结果 ")
const _hoisted_27 = /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9 3L14 8M14 8L9 13M14 8H2",
    stroke: "#565B66",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)

import { ref, onMounted, onUnmounted } from 'vue'
import debounce from 'lodash/debounce'
import { isAndroidNative as isAndroid, isIOSNative as isIOS } from '@xunlei/universal-native-api'
import { noop } from '@remote/utils/base'
import { usePromisifyDialog } from '@shared/utils/dialog'
import { openCinemaSeries} from '@remote/utils/dialog'
import PopWrapper from '@remote/components/PopWrapper.vue'
import throttle from 'lodash/throttle'
import { store } from '@remote/store'
import { useCinemaStore } from '@remote/store/cinema'
import { toast } from '@remote/utils'
import { router } from '@remote/router'
import { 
  useCinemaSearch, 
  TSearchResourceRetItem,
  getHistoryLocalCache,
  addHistoryLocalCache,
  removeHistoryLocalCache,
  removeAllHistoryLocalCache,
} from '@remote/store/cinemaSearch'
import Loading from '@remote/components/Loading.vue'
import SearchPage from '@remote/views/cinema/Search.vue'
import isLargeViewPort from '@remote/utils/use-hooks/use-is-large-viewport'
import Modal from '@remote/components/modal'


export default /*#__PURE__*/_defineComponent({
  emits: ["dialog-close"],
  setup(__props, { emit }: { emit: ({
  (e: 'dialog-close'): void
}), expose: any, slots: any, attrs: any }) {


const SHOWMAXLISTNUMS = isLargeViewPort.value ? 4 : 8
const { data, setSearchPhase, cleanSearchPhase, searchScrape, abnormal } = useCinemaSearch()
const { isShow, close } = usePromisifyDialog(emit)
const cinemaStore = useCinemaStore()
const isVisibleResult = ref(false)
const inputRef = ref()

const handleClose = () => {
  close(null)
  cleanSearchPhase()
}

const historys = ref(getHistoryLocalCache())

const removeHistorys = (index: number) => {
  historys.value = removeHistoryLocalCache(historys.value[index])
}

const handleOnRemoveAllHistorys = () => {
  Modal.Delete({
    title: '确认删除所有历史记录吗？',
    cancelText: '取消',
    okText: '删除',
    onOk: () => {
      historys.value = []
      removeAllHistoryLocalCache()
    },
  })
}

const handleOnSearchResource = throttle((evt) => {
  if (isVisibleResult.value) return
  const name = evt.target.value
  if (name) setSearchPhase(name)
}, 1000)

const handleOnClickSearchItem = debounce((episode: TSearchResourceRetItem) => {
  if (episode.id) {
    if (episode.isTV) {
      const params = {
        nfo: {
          video_info: episode ,
          scrape_result: episode.scrape_info,
        },
      }
      openCinemaSeries(params as  API_NFO.NFO)
      handleClose()
    } else {
      const apiUrl = episode.isOther ? '/drive/v2/files' : '/drive/v1/files'
      const scene = episode.isOther ? 'heziFile': 'nfo'
      store.dispatch('getFileInfo', {
        space: 'hezi',
        apiUrl,
        path: episode?.file_path || '',
        size: String(episode?.file_size),
        id: episode.id,
        hash: episode.hash,
        usage: 'PLAY',
        theme: 'dark',
        scene,
        mime_type: 'video/*',
        name: episode.name,
      }).then(() => {
        cinemaStore.refreshRecentNFOList()
      }).catch(() => {
        toast('播放失败，请检查文件是否存在')
      }).finally(() => {
        cinemaStore.setPlaying(false)
      })
    }
  } else {
    toast('播放失败，请检查文件是否存在')
  }
}, 500, {
  leading: true,
  trailing: false,
})

const handleSetSearchName = (keyWord: string) => {
  setSearchPhase(keyWord)
}

const gotoViewResult = () => {
  if (!isLargeViewPort.value) {
    isVisibleResult.value = true
  } else {
    router.push('cinema-search')
    close(null)
  }
  if (data.phase) addHistoryLocalCache(data.phase)
  searchScrape('all', true)
  searchScrape('movie')
  searchScrape('tv')
  searchScrape('other')
}

const handleOnEnter = (e) => {
  if (e.keyCode==13) gotoViewResult()
}

onMounted(() => {
  setTimeout(() => {
    if (inputRef.value) {
      inputRef.value.focus()
      inputRef.value.select()
    }
  }, 200)
  window.document.addEventListener('keydown', handleOnEnter)
})

onUnmounted (() => {
  window.document.removeEventListener('keydown', handleOnEnter)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopWrapper, {
    close: _unref(noop),
    "is-show": _unref(isShow)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["cinema-search is-dark", { 'android-padding': _unref(isAndroid), 'ios-padding': _unref(isIOS) }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("i", {
            class: "qh-icon-back",
            onClick: handleClose
          }),
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _withDirectives(_createElementVNode("input", {
              ref_key: "inputRef",
              ref: inputRef,
              placeholder: "请输入影片名称",
              onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(handleOnSearchResource) && _unref(handleOnSearchResource)(...args))),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(data).phase) = $event))
            }, null, 544), [
              [_vModelText, _unref(data).phase]
            ]),
            _withDirectives(_createElementVNode("span", {
              class: "clear",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(cleanSearchPhase) && _unref(cleanSearchPhase)(...args)))
            }, "清空", 512), [
              [_vShow, _unref(data).phase]
            ]),
            _createElementVNode("i", {
              class: "icomoon-close",
              onClick: handleClose
            })
          ]),
          _createElementVNode("a", {
            class: "search-btn",
            onClick: gotoViewResult
          }, "搜索")
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (!isVisibleResult.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (!_unref(data).phase)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _hoisted_8,
                          (historys.value.length)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                onClick: handleOnRemoveAllHistorys
                              }, "全部清除"))
                            : _createCommentVNode("", true),
                          (historys.value.length)
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 1,
                                class: "icomoon-delete",
                                onClick: handleOnRemoveAllHistorys
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        (historys.value.length)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(historys.value, (key, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "search-history-item",
                                key: key,
                                onClick: ($event: any) => (handleSetSearchName(key))
                              }, [
                                _createElementVNode("span", null, [
                                  _hoisted_10,
                                  _createTextVNode(" " + _toDisplayString(key), 1)
                                ]),
                                _createElementVNode("i", {
                                  class: "icomoon-clean",
                                  onClick: _withModifiers(($event: any) => (removeHistorys(index)), ["stop"])
                                }, null, 8, _hoisted_11)
                              ], 8, _hoisted_9))
                            }), 128))
                          : (_openBlock(), _createElementBlock("div", _hoisted_12, " 暂无搜索记录 "))
                      ]))
                    : (_unref(data).filesIds.all.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).filesIds.all.slice(0, _unref(SHOWMAXLISTNUMS)), (id) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: id,
                              class: _normalizeClass(["search-result-item", { other: _unref(data).map[id]?.isOther }]),
                              onClick: ($event: any) => (_unref(handleOnClickSearchItem)(_unref(data).map[id]))
                            }, [
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("img", {
                                  class: "poster",
                                  src: _unref(data).map[id]?.postUrl
                                }, null, 8, _hoisted_16)
                              ]),
                              _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("h4", {
                                  innerHTML: _unref(data).map[id]?.displayName
                                }, null, 8, _hoisted_18),
                                _createElementVNode("div", _hoisted_19, [
                                  _createElementVNode("span", null, _toDisplayString(_unref(data).map[id]?.class === 'tv' ? '电视剧' : '电影'), 1),
                                  (_unref(data).map[id]?.year)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_unref(data).map[id]?.year), 1))
                                    : _createCommentVNode("", true),
                                  (_unref(data).map[id]?.originPlace)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_unref(data).map[id]?.originPlace), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("p", _hoisted_22, _toDisplayString(_unref(data).map[id]?.displayEpisode), 1)
                              ])
                            ], 10, _hoisted_14))
                          }), 128))
                        ]))
                      : (_unref(data).loading['all'])
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _createVNode(Loading)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _createElementVNode("i", {
                              class: _normalizeClass(_unref(abnormal).type)
                            }, null, 2),
                            _createElementVNode("p", null, _toDisplayString(_unref(abnormal).type ? _unref(abnormal).errorMessage : '没有搜索到符合条件的影片，请换个搜索词后试试吧~'), 1)
                          ])),
                  (!!_unref(data).phase)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 4,
                        class: "search-result-footer",
                        onClick: gotoViewResult
                      }, [
                        _createElementVNode("span", null, [
                          _hoisted_25,
                          _createElementVNode("label", null, "“" + _toDisplayString(_unref(data).phase) + "”", 1),
                          _hoisted_26,
                          _hoisted_27
                        ]),
                        _withDirectives(_createElementVNode("i", null, "Enter ", 512), [
                          [_vShow, _unref(data).filesIds.all.length]
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createBlock(SearchPage, {
                  key: 1,
                  onClickTvItem: handleClose
                }))
          ])
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["close", "is-show"]))
}
}

})